import dayjs from 'dayjs'

const orderStatusToTextMap = {
  wait: 'รอดำเนินการ',
  booking: 'เตรียมจัดส่ง',
  shipping: 'อยู่ระหว่างการจัดส่ง',
  complete: 'ส่งสินค้าเรียบร้อย',
  cancel: 'ถูกยกเลิก',
  pending_transfer: 'ส่งสินค้าเรียบร้อย',
  transferred: 'ส่งสินค้าเรียบร้อย',
  cancel_transfer: 'ถูกยกเลิก',
  return: 'ถูกตีกลับ',
}

const orderStatusToTextMapEng = {
  wait: 'Pending',
  booking: 'Waiting for shipment',
  shipping: 'Shipping',
  complete: 'Completed',
  cancel: 'Cancelled',
  pending_transfer: 'Pending transfer',
  transferred: 'Transferred',
  cancel_transfer: 'Transfer cancelled',
  return: 'Returned'
}

const orderStatusToStepMap = {
  wait: 0,
  booking: 1,
  shipping: 2,
  complete: 3,
  cancel: -1,
  pending_transfer: 3,
  transferred: 3,
  cancel_transfer: -1,
  return: -1,
}

const interOrderStatusToTextMap = {
  waiting: 'รอดำเนินการ',
  invalid: 'ไม่ถูกต้อง',
  booking: 'เตรียมจัดส่ง',
  shipping: 'อยู่ระหว่างการจัดส่ง',
  pending: 'เกิดข้อผิดพลาด',
  complete: 'ส่งสินค้าเรียบร้อย',
  cancel: 'ถูกยกเลิก',
}

const interOrderStatusToTextMapEng = {
  waiting: 'Pending',
  invalid: 'Invalid',
  booking: 'Prepare to ship',
  shipping: 'Shipping',
  pending: 'Something went wrong',
  complete: 'Completed',
  cancel: 'Cancelled',
}

const interOrderStatusToStepMap = {
  waiting: 0,
  invalid: -1,
  booking: 1,
  shipping: 2,
  pending: 2,
  complete: 3,
  cancel: -1,
}

const groupByOrderStatus = (data) => {
  // const sorted = data.sort((a, b) => dayjs(b.datetime_shipping) - dayjs(a.datetime_shipping))
  let group = data.reduce((acc, cur) => {
    const proArr = acc[cur.order_status]

    return {
      ...acc,
      [cur.order_status]: proArr ? [...proArr, cur] : [cur]
    }
  }, {})

  group = { all: [...data], ...group }

  return group
}

export {
  orderStatusToStepMap,
  orderStatusToTextMap,
  orderStatusToTextMapEng,
  interOrderStatusToStepMap,
  interOrderStatusToTextMap,
  interOrderStatusToTextMapEng,
  groupByOrderStatus,
}